<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form
    [formGroup]="brandForm"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
    (ngSubmit)="saveBrand()"
  >
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-tags mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-tag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="brandName"
                id="brandName"
                class="w-full"
                placeholder="Enter brand name"
              />
              <label for="brandName">Brand Name</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                pInputText
                type="text"
                formControlName="brandCode"
                id="brandCode"
                class="w-full"
                placeholder="Enter brand code"
              />
              <label for="brandCode">Brand Code</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <app-entity-dropdown-picker
          formControlName="business"
          [adapter]="businessPickerAdapter"
          inputId="business"
          label="Business"
          placeholder="Select a Business"
          filterPlaceholder="Filter businesses"
          columnClass="col-12 md:col-6"
          addonIconClass="pi pi-building"
        ></app-entity-dropdown-picker>
      </div>
    </div>

    <div class="mt-4 flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        styleClass="p-button-secondary"
        type="button"
        (onClick)="cancel()"
      ></p-button>
      <p-button
        [label]="isEditMode ? 'Update Brand' : 'Save Brand'"
        type="submit"
        [disabled]="brandForm.invalid"
      ></p-button>
    </div>
  </form>
</div>
